import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoTitle, mobileLogo, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView column center w="100%">
          <CFImage
            mt="20px"
            w="171px"
            src={mobileLogo}
            alt="Tsuki Sushi Logo"
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          w="100%"
          bg="rgba(0,0,0,0.75)"
          h="65px"
          row
          alignStart
          zIndex={98}
        >
          <CFImage
            ml="4%"
            maxWidth="180px"
            src={logo}
            alt="Tsuki Sushi Logo"
            zIndex={98}
          />
          <CFView ml="5px" mt="10px">
            <LocationSelect />
          </CFView>
          {/* <CFView
            mt="10px"
            ml="10px"
            center
            br="30px"
            bc="red"
            bw="3px"
            pv="5px"
            ph="15px"
            zIndex={99}
          >
            <CFView h2 color="red" xBold mb="2px">
              VANCOUVER
            </CFView>
          </CFView> */}
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
